import { render } from "./ParcimmoList.vue?vue&type=template&id=a9f056b2"
import script from "./ParcimmoList.vue?vue&type=script&lang=js"
export * from "./ParcimmoList.vue?vue&type=script&lang=js"

import "./ParcimmoList.vue?vue&type=style&index=0&id=a9f056b2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__